<!-- Start: Rejwan: 14-05-2025 Settlement -->
<template>
    <div class="employee-tab-inner">
        <b-overlay rounded="sm">
            <div class="payroll-reporting-tab" id="nav-tabContent-intro" v-if="$acl['gf/leaverlist'] > 0 ">
                <b-tabs content-class="mt-3 reports-tab pb-4" nav-wrapper-class="reports-tab-nav">
                    
                    <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Awaiting Settlement</h5>
                                <p>List of Deregistered Applicants Awaiting Settlement</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>
                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-dereg-leaver-list :pageurl="this.$api_url" is_action="1" from="awaiting_settlement"></gf-dereg-leaver-list>
                            </template>
                            <template v-else>
                                <gf-dereg-leaver-list :pageurl="this.$api_url" is_action="0" from="awaiting_settlement"></gf-dereg-leaver-list>
                            </template>
                            
                        </div>
                    </b-tab>
                    
                    <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Deferred Settlement Applications</h5>
                                <p>List of Deferred Settlement Applications</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <!-- Start: Rejwan: 18-05-2025 Deferred Settlements -->
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-deferred-settlement :pageurl="this.$api_url" is_action="1"></gf-deferred-settlement>
                            </template>
                            <template v-else>
                                <gf-deferred-settlement :pageurl="this.$api_url" is_action="0"></gf-deferred-settlement>
                            </template>
                            <!-- End: Rejwan: 18-05-2025 Deferred Settlements -->
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Rejected Settlement Applications</h5>
                                <p>List of Rejected Settlement Applications</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <!-- Start: Rejwan: 18-05-2025 Deferred Settlements -->
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-settlement-rejected-list :pageurl="this.$api_url" is_action="1"></gf-settlement-rejected-list>
                            </template>
                            <template v-else>
                                <gf-settlement-rejected-list :pageurl="this.$api_url" is_action="0"></gf-settlement-rejected-list>
                            </template>
                            <!-- Start: Rejwan: 18-05-2025 Deferred Settlements -->
                        </div>
                    </b-tab>

                    <!-- <b-tab lazy> --> <!-- Rejwan: 04-05-2025 -->
                    <!-- <b-tab lazy v-if="this.site_options.require_consent != 0"> 
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Awaiting Consent</h5>
                                <p>List of Settlement Applications Awaiting Former Member Consent</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1" >
                                <pf-settlement-awaiting-consent :pageurl="this.$api_url" is_action="1"></pf-settlement-awaiting-consent>
                            </template>
                            <template v-else>
                                <pf-settlement-awaiting-consent :pageurl="this.$api_url" is_action="0"></pf-settlement-awaiting-consent>
                            </template>
                            
                        </div>
                    </b-tab> -->
                    
                    <!-- <b-tab lazy> --> <!-- Rejwan: 04-05-2025 -->
                    <b-tab lazy v-if="this.site_options.approver_setting > 0"> <!-- Rejwan: 04-05-2025 -->
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Awaiting Approval</h5>
                                <p>List of Settlement Applications Awaiting Approval</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                             <!-- Start: Rejwan: 19-05-2025 Awaiting Approval -->
                            <template v-if="$acl['gf/leaverlist'] > 1"> <!-- need to update acl for gf -->
                                <gf-settlement-awaiting-approval :pageurl="this.$api_url" is_action="1"></gf-settlement-awaiting-approval>
                            </template>
                            <template v-else>
                                <gf-settlement-awaiting-approval :pageurl="this.$api_url" is_action="0"></gf-settlement-awaiting-approval>
                            </template>
                             <!-- End: Rejwan: 19-05-2025 Awaiting Approval -->
                            
                        </div>
                    </b-tab>

                    <!-- <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Awaiting Disbursement</h5>
                                <p>List of Settlement Applications Awaiting Disbursement</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                    
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-awaiting-disbursement :pageurl="this.$api_url" is_action="1"></gf-awaiting-disbursement>
                            </template>
                            <template v-else>
                                <gf-awaiting-disbursement :pageurl="this.$api_url" is_action="0"></gf-awaiting-disbursement>
                            </template>
                        </div>
                    </b-tab> -->

                    <!-- <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Settlements On Hold</h5>
                                <p>List of Approved Settlements On Hold</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-settlement-on-hold  :pageurl="this.$api_url" is_action="1"></gf-settlement-on-hold >
                            </template>
                            <template v-else>
                                <gf-settlement-on-hold  :pageurl="this.$api_url" is_action="0"></gf-settlement-on-hold >
                            </template>
                        </div>
                    </b-tab> -->

                    <b-tab lazy>
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Disbursed Settlement.png'"
                                    class="light-mode-icon" />
                                <!-- Start: Rejwan: 27-04-2025 spelling correction -->
                                <h5>Disbursed Settlement List</h5>
                                <p>List of Successfully Disbursed Settlement Applications</p>
                                <!-- End: Rejwan: 27-04-2025 spelling correction -->
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <!-- Start: Rejwan: 19-05-2025 On Hold -->
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <gf-settlement-disbursed  :pageurl="this.$api_url" is_action="1"></gf-settlement-disbursed>
                            </template>
                            <template v-else>
                                <gf-settlement-disbursed  :pageurl="this.$api_url" is_action="0"></gf-settlement-disbursed>
                            </template>
                            <!-- End: Rejwan: 19-05-2025 On Hold -->
                        </div>
                    </b-tab>

                    <!-- Start: Rejwan: 08-05-2025 Batch Mailing Feature -->
                    <!-- <b-tab lazy v-if="batch_mailing_enable">
                        <template #title>
                            <div
                                class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">
                                <img v-bind:src="$api_url+ '/images/Settlement.png'"
                                    class="light-mode-icon" />
                                <h5>Batch Mailing Settlements</h5>
                                <p>List of All Settlements for Batch Mailing</p>
                                <b-button class="btn btn-primary">View</b-button>
                            </div>
                        </template>

                        <div class="">
                            <template v-if="$acl['gf/leaverlist'] > 1">
                                <pf-settlement-all :pageurl="this.$api_url" is_action="1"></pf-settlement-all >
                            </template>
                            <template v-else>
                                <pf-settlement-all :pageurl="this.$api_url" is_action="0"></pf-settlement-all >
                            </template>
                           
                        </div>
                    </b-tab> -->
                    <!-- End: Rejwan: 08-05-2025 Batch Mailing Feature -->
                </b-tabs>
               

            </div>
        </b-overlay>

        
    </div>
</template>
<script>
export default{
    props: ['flg','pageurl'],
    data(){      
        return {
            dreg_show:1,
            site_options: [], // Rejwan: 04-05-2025
            batch_mailing_enable: true, // Rejwan: 08-05-2025 Batch Mailing Feature
        }
    },
    // Start: Rejwan: 04-05-2025
    methods: {
        // Start: Rejwan: 08-05-2025 Batch Mailing Feature
        getBatchMailingSetting() {
                axios.get(this.$api_url+'/approver/get-batch-mailing', {
                params: {
                    module: 9,                        
                }
            }).then(function(response){
                this.batch_mailing_enable = response.data;
            }.bind(this));
        },
        // End: Rejwan: 08-05-2025 Batch Mailing Feature
        getSettlementSiteOption: function () {
            axios.get(this.$api_url + '/gf/settlement/site-options', {
                
            }).then(function (response) {
                this.site_options = response.data;
            }.bind(this));
        },
    },
    created: function () {
        this.getSettlementSiteOption();
        this.getBatchMailingSetting() // Rejwan: 08-05-2025 Batch Mailing Feature
    }
    // End: Rejwan: 04-05-2025
}
</script>

<!-- End: Rejwan: 14-05-2025 Settlement -->